import React from 'react';
import Chart from 'react-apexcharts';

export const RevenueChart = (props: {
    revenue_daily: { x: number; y: number }[];
    revenue_cumulative: { x: number; y: number }[];
    objective: number,
    title: string;
}) => {
    return (
        <Chart
            height="400"
            type="area"
            series={[
                { name: 'Daily', data: props.revenue_daily },
                { name: 'Cumulative', data: props.revenue_cumulative }
            ]}
            options={{
                chart: {
                    type: 'area',
                    height: 400,
                    zoom: {
                        enabled: false
                    }
                },
                dataLabels: {
                    enabled: false
                },
                title: { text: props.title },
                stroke: {
                    curve: 'straight'
                },
                fill: {
                    type: 'gradient'
                },
                xaxis: {
                    type: 'datetime'
                },
                tooltip: {
                    y: {
                        formatter: (val) => {
                            return `${Intl.NumberFormat('fr-FR').format(val)}€`;
                        }
                    }
                },
                yaxis: {
                    labels: {
                        formatter: (val) => {
                            return `${Intl.NumberFormat('fr-FR').format(val)}€`;
                        }
                    },
                    max: (val) => { return Math.max(val, 5150000); }
                },
                annotations: {
                    xaxis: [
                        {
                            x: new Date().getTime() - new Date().getTimezoneOffset() * 60 * 1000,
                            borderColor: '#999',
                            label: {
                                text: 'Today',
                                style: {
                                    color: '#fff',
                                    background: '#775DD0'
                                }
                            }
                        }
                    ],
                    yaxis: [
                        {
                            y: 5150000,
                            borderColor: '#999',
                            label: {
                                text: 'Objectif',
                                style: {
                                    color: '#fff',
                                    background: '#775DD0'
                                }
                            }
                        }
                    ]
                }
            }}
        ></Chart>
    );
};
